// page-goods ページのjs
import htmx from "htmx.org";
import { swiperThumbnail } from "../modules/_swiper-thumbnail";
import "../sass/page-goods.scss";

document.addEventListener("DOMContentLoaded", () => {
  const sliderLength = document.querySelectorAll(".swiper").length;
  for (let i = 1; i < sliderLength; i += 1) {
    swiperThumbnail(`.goods-swiper-${i}`, `.goods-thumb-${i}`);
  }
});

// ▼▼▼▼▼ DOMが安定した後に実行
const HTMX_ELM_COUNT = htmx.findAll(`[hx-trigger="load"]`).length;
let LOADED_COUNT = 0;
htmx.on("htmx:afterSettle", () => {
  LOADED_COUNT += 1;

  if (HTMX_ELM_COUNT === LOADED_COUNT) {
    // ここにDOMが安定した後に実行したい処理を記述する
  }
});
// ▲▲▲▲▲
